import Vue from 'vue'
import VueRouter from 'vue-router'

const routes = [
  { path: '/', component: () => import('@/vue/Main.vue') },
  {
    path: '/main',
    name: 'main',
    component: () => import('@/vue/Main.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/regular',
    name: 'regular',
    component: () => import('@/vue/RegularEyes.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/result_regular',
    name: 'result_regular',
    component: () => import('@/vue/ResultRegular.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/complex',
    name: 'complex',
    component: () => import('@/vue/ComplexEyes.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/result_complex',
    name: 'result_complex',
    component: () => import('@/vue/ResultComplex.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/second',
    name: 'second',
    component: () => import('@/vue/SecondEyes.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/result_second',
    name: 'result_second',
    component: () => import('@/vue/ResultSecond.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/toric',
    name: 'toric',
    component: () => import('@/vue/Toric.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/result_toric',
    name: 'result_toric',
    component: () => import('@/vue/ResultToric.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/emailconfirmation/:token/:email',
    name: 'emailconfirmation',
    component: () => import('@/vue/EmailConfirm.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/camera-capture',
    name: 'CameraCapture',
    component: () => import('@/vue/CameraCapture.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  // for dev do not commit
  // {
  //   path: '/test-vue',
  //   name: 'test-vue',
  //   component: () => import('@/components/test/Test.vue'),
  //   meta: {
  //     requiresAuth: false,
  //   },
  // },
]

Vue.use(VueRouter)
const router = new VueRouter({
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // },
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // https://router.vuejs.org/guide/advanced/scroll-behavior.html
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt-token') == null) {
      next({
        path: '/',
        params: { nextUrl: to.fullPath, showPopUp: true },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
